var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.678 13.1794C13.5231 13.1794 14.2135 12.4793 14.2135 11.6226C14.2135 10.588 12.678 8.89969 12.678 8.89969C12.678 8.89969 11.1425 10.588 11.1425 11.6226C11.1425 12.4793 11.8329 13.1794 12.678 13.1794ZM5.3853 12.3265C5.5226 12.4639 5.745 12.4639 5.88037 12.3265L10.8331 7.37579C10.9704 7.23848 10.9704 7.01609 10.8331 6.88072L5.88231 1.92996C5.8707 1.91836 5.85717 1.90675 5.84363 1.89708L4.33133 0.384783C4.29836 0.352235 4.25389 0.333984 4.20756 0.333984C4.16123 0.333984 4.11676 0.352235 4.08379 0.384783L3.15552 1.31305C3.12297 1.34602 3.10472 1.39049 3.10472 1.43682C3.10472 1.48315 3.12297 1.52762 3.15552 1.56059L4.4551 2.86016L0.436476 6.88072C0.29917 7.01802 0.29917 7.24042 0.436476 7.37579L5.3853 12.3265ZM5.63477 3.65112L9.09449 7.11085H2.17698L5.63477 3.65112Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.7c439d1cea35f3b1a3c4d45bfcaeee18.svg";
export { ForwardRef as ReactComponent };